import {Entity} from "@/store/Database";

interface MutableMappingComponent {
    /** マッピング先のエンティティー */
    mappingTo: Entity<any> | null;

    /** 取り込んだ後、データを置き換える際に使用するキー */
    replaceTo: string | null;

    /** 置き換えに使用するオブジェクトのキーが存在しない場合、任意のIDを生成する場合 true そうでない場合 false */
    isGenerateId: boolean;

    /** 主キーの重複を許可する場合 true そうでない場合 false */
    isAllowDuplicate: boolean;

    /** オブジェクトを元の位置から削除する場合 true そうでない場合 false */
    isDelete: boolean;

    /** 変更記録しない場合 true そうでない場合 false */
    isDisableChangesApi: boolean;
}

export class MappingComponent implements Readonly<MutableMappingComponent> {
    /** マッピング先のエンティティー */
    public readonly mappingTo: Entity<any> | null;

    /** 取り込んだ後、データを置き換える際に使用するキー */
    public readonly replaceTo: string | null;

    /** 置き換えに使用するオブジェクトのキーが存在しない場合、任意のIDを生成する場合 true そうでない場合 false */
    public readonly isGenerateId: boolean;

    /** 主キーの重複を許可する場合 true そうでない場合 false */
    public readonly isAllowDuplicate: boolean;

    /** オブジェクトを元の位置から削除する場合 true そうでない場合 false */
    public readonly isDelete: boolean;

    /** 変更記録しない場合 true そうでない場合 false */
    public readonly isDisableChangesApi: boolean;

    /** パス */
    private readonly path: string[];

    /**
     * コンストラクタ
     *
     * @param mappingTo マッピング先のエンティティー
     * @param pattern ユーザーが指定したマッピングパターン文字列
     */
    constructor(mappingTo: Entity<any> | null, pattern: string) {
        const m = /^([^>*?-]+)(>\s*([^*+?-]*)([+]*))?\s*([*?-]*)/.exec(pattern);
        if(!m) {
            throw new Error(`Illegal pattern: ${pattern}`)
        }

        this.mappingTo = mappingTo;
        this.path = m[1].split('.').map(path => path.trim());
        this.replaceTo = m[3] ? m[3].trim() : null;
        this.isGenerateId = !!m[4] && m[4].indexOf('+') !== -1;
        this.isDelete = !!m[5] && m[5].indexOf('-') !== -1;
        this.isAllowDuplicate = !!m[5] && m[5].indexOf('*') !== -1;
        this.isDisableChangesApi = !!m[5] && m[5].indexOf('?') !== -1;
    }

    /**
     * 指定されたパスとこのインスタンスのパスが等価かどうかを返します
     *
     * @param other 比較対象のパス
     * @return 指定されたパスとこのインスタンスのパスが等価の場合 true そうでない場合 false
     */
    public pathEquals(other: string[]): boolean {
        if(this.path.length !== other.length) {
            return false;
        }
        for(let i=0; i<this.path.length; i++) {
            if(this.path[i] !== other[i]) {
                return false;
            }
        }
        return true;
    }

    /**
     * このインスタンスのパスの長さを返します
     */
    public get pathLength(): number {
        return this.path.length;
    }

    /**
     * プロパティを変更して新しいインスタンスを生成します
     *
     * @param replacement 変更内容
     * @return 新しいインスタンス
     */
    public with(replacement: Partial<MutableMappingComponent>): MappingComponent {
        return Object.assign(
            Object.create(Object.getPrototypeOf(this)),
            this,
            replacement
        ) as MappingComponent;
    }
}
